import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { DateService } from '@/common/date.service';
import { DataBagService } from '@/common/data-bag.service';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { LoaderService } from '@/common/loader/loader.service';

const POLISH_ZLOTY_CURRENCY_ID = 1;
const PRICE_OPTIONS_WITH_AGE_RANGE = ['Opłata programowa - dziecko', 'Opłata programowa - senior'];

@Component({
	selector: 'app-group-offer-price-setting',
	templateUrl: './group-offer-price-setting.component.html',
	styleUrls: ['./group-offer-price-setting.component.css'],
})
export class GroupOfferPriceSettingComponent implements OnChanges, OnInit {
	@Input() currency: Array<any>;
	@Input() board: Array<any>;
	@Input() data: any;
	@Input() editable: boolean;
	@Input() priceSetting: any;
	@Input() priceOption: Array<any>;
	@Input() termData: any;
	@Input() productData: any;
	@Output() afterGenerate = new EventEmitter();
	@Output() closeDialog = new EventEmitter();
	@Input() buttonnone: boolean;

	dataToSend: any;
	selectedCurrency = {
		code: null,
		exchangeRatePln: null,
		id: null,
		name: null,
	};

	priceSettingUrl = '';
	priceSettingData: {
		chargingMode: string;
		crewCost: null | number;
		currency: number;
		groups: any[];
		id: null | number;
		priceSettingBoards: any[];
		priceSettingsPriceOptions: any[];
	} = {
		chargingMode: 'D',
		crewCost: null,
		currency: 1,
		groups: [],
		id: null,
		priceSettingBoards: [],
		priceSettingsPriceOptions: [],
	};
	holdPriceSettingPrice;
	groupToSend = [];
	productToSend = [];
	termToSend = [];
	priceSettingsToUpdate = [];

	ngOnInit() {
		this.loader.hide();
	}

	ngOnChanges(): void {
		if (this.priceSetting == undefined) {
			return;
		}
		if (this.priceSetting !== false && this.priceSetting.length !== 0) {
			this.priceSettingData = this.priceSetting;
			if (this.priceSettingData.currency !== undefined) {
				this.priceSettingData.priceSettingBoards.map((item) => {
					this.board.filter((el, index, arr) => {
						if (item.board.id == el.id) {
							arr[index]['cost'] = item.cost;
							arr[index]['sellingPrice'] = item.price;
							arr[index]['isActive'] = item.isActive;
						}
					});
				});
				this.priceSettingData.priceSettingsPriceOptions.map((item) => {
					this.priceOption.filter((el, index, arr) => {
						if (item.priceOption.id == el.id) {
							arr[index]['cost'] = parseFloat(item.methodValue);
							arr[index]['isActive'] = item.isActive;
							arr[index]['currency'] = item.currency?.id ?? POLISH_ZLOTY_CURRENCY_ID;
							arr[index]['ageFrom'] = item.ageFrom ?? null;
							arr[index]['ageTo'] = item.ageTo ?? null;
						}
					});
				});
				this.valuechange();
			}
		}
		this.changeCurrency();
		this.holdPriceSettingPrice = this.priceSetting.crewCost;
	}

	changeCurrency() {
		this.selectedCurrency = this.currency.find((obj) => obj.id == this.priceSettingData.currency);
	}

	valuechange() {
		if (this.selectedCurrency === undefined) {
			return;
		}
		this.changeCurrency();
		this.board.map((item) => {
			const exchangeRatePln = this.selectedCurrency.exchangeRatePln / 100;
			if (item.cost !== undefined && item.cost !== null) {
				item.cost = Number(item.cost);
				const discountsCost = parseFloat(item.cost);
				item.costPLN = Number(item.cost * exchangeRatePln);
				item.cost = discountsCost;
			}

			if (typeof item.cost !== 'number' && typeof item.sellingPrice === 'number') {
				item.cost = 0;
				item.costPLN = 0;
			}

			if (typeof item.cost === 'number' && typeof item.sellingPrice !== 'number') {
				item.sellingPrice = 0;
			}

			if (item.sellingPrice !== null && item.sellingPrice !== undefined) {
				item.sellingPrice = Number(item.sellingPrice);
			}

			if (item.costPLN === 0) {
				item.costPLN = null;
			}
		});
	}

	convertDecimal() {
		this.priceOption.map((item) => {
			if (item.cost == null) {
				return;
			}

			const discountsCost = parseFloat(item.cost.toFixed(2));

			item.cost = discountsCost;
		});
	}

	digitLimit(event: any) {
		if (event.target.value.length == 8 && event.keyCode !== 8) return false;
	}

	clearBoard(i) {
		this.board[i].cost = null;
		this.board[i].costPLN = null;
		this.board[i].sellingPrice = null;
		this.board[i].isActive = false;
	}

	delEmptyForm() {
		this.dataToSend.priceSettingsPriceOptions.map((item, index) => {
			if (item.methodValue === null) {
				this.priceSettingData.priceSettingsPriceOptions.splice(index, 1);
				this.dataToSend.priceSettingsPriceOptions.splice(index, 1);
			}
			this.priceOption.map((el) => {
				if (el.cost === null) {
					delete el.cost;
				}
			});
		});
		this.dataToSend.priceSettingBoards.map((item, index) => {
			if (item.cost == null || item.price == null) {
				this.priceSettingData.priceSettingBoards.splice(index, 1);
				this.dataToSend.priceSettingBoards.splice(index, 1);
			}
			this.board.map((el) => {
				if (el.cost == null || el.sellingPrice == null) {
					delete el.cost;
					delete el.sellingPrice;
				}
			});
		});
	}

	groupOfferSend(priceSettingsPriceOptions, priceSettingBoards) {
		this.groupToSend = [this.data.id];
		this.dataToSend = {
			id: null,
			currency: this.priceSettingData.currency,
			crewCost: this.priceSettingData.crewCost,
			groupSet: this.groupToSend,
			termSet: this.termToSend,
			productSet: this.productToSend,
			chargingMode: this.priceSettingData.chargingMode,
			priceSettingsPriceOptions: priceSettingsPriceOptions,
			priceSettingBoards: priceSettingBoards,
		};

		this.delEmptyForm();
		this.priceSettingSend();
	}

	async productSend(priceSettingsPriceOptions, priceSettingBoards) {
		this.productToSend = [this.productData.id];
		this.dataToSend = {
			id: null,
			currency: this.priceSettingData.currency,
			crewCost: this.priceSettingData.crewCost,
			groupSet: this.groupToSend,
			termSet: this.termToSend,
			productSet: this.productToSend,
			chargingMode: this.priceSettingData.chargingMode,
			priceSettingsPriceOptions: priceSettingsPriceOptions,
			priceSettingBoards: priceSettingBoards,
		};

		this.delEmptyForm();
		await this.priceSettingSend();
	}

	termSend(priceSettingsPriceOptions, priceSettingBoards) {
		this.termData.map((item) => {
			this.termToSend.push(item.id);
			item.pricePriority = 'T';

			const selectedBoard = priceSettingBoards.find((element) => element.board == item.product.board);
			if (selectedBoard == undefined || selectedBoard.isActive == false) {
				item.product.boardTooltip = `Nie ustawiono ceny dla tego wyżywienia lub jest nieaktywna`;
			} else {
				item.product.boardTooltip = `Cena sprzedaży: ${selectedBoard.price} PLN`;
			}
		});
		this.dataToSend = {
			id: null,
			currency: this.priceSettingData.currency,
			crewCost: this.priceSettingData.crewCost,
			groupSet: [],
			termSet: this.termToSend,
			productSet: [],
			chargingMode: this.priceSettingData.chargingMode,
			priceSettingsPriceOptions: priceSettingsPriceOptions,
			priceSettingBoards: priceSettingBoards,
		};

		this.delEmptyForm();
		this.priceSettingSend();
	}

	priceSettingSend() {
		if (this.priceSetting.id == null) {
			return new Promise((resolve, reject) => {
				this.bag.post('/offer/price_setting/', this.dataToSend, (result, error) => {
					this.loader.hide();
					if (result) resolve(true);
					else reject();
					this.afterSend(result, error);
					this.afterGenerate.emit();
				});
			});
		} else {
			return new Promise((resolve, reject) => {
				this.bag.put('/offer/price_setting/' + this.priceSetting.id + '/', this.dataToSend, (result, error) => {
					this.loader.hide();
					if (result) resolve(true);
					else reject();
					this.afterSend(result, error);
					this.afterGenerate.emit();
				});
			});
		}
	}

	isSomeCostWithoutCurrency(): boolean {
		const isCostWithoutCurrency = (cost: number, currency: number) => {
			if (cost && !currency) {
				this.infobox.error('Pole waluta nie może być puste, gdy uzupełniłeś pole koszt');
				return true;
			}
			return false;
		};

		return this.priceOption.some(({ cost, currency }) => isCostWithoutCurrency(cost, currency));
	}

	hasAgeRange(priceOption: { name?: string }): boolean {
		if (!priceOption?.name) {
			return false;
		}

		return PRICE_OPTIONS_WITH_AGE_RANGE.includes(priceOption.name);
	}

	isSomeAgeRangeInvalid(): boolean {
		const isAgeRangeInvalid = (ageFrom: number, ageTo: number) => {
			if (ageFrom != null && ageTo != null && ageFrom > ageTo) {
				this.infobox.error('Pole "Wiek od" nie może być większe niż pole "Wiek do"');
				return true;
			}
			return false;
		};

		return this.priceOption
			.filter((option) => this.hasAgeRange(option))
			.some(({ ageFrom, ageTo }) => isAgeRangeInvalid(ageFrom, ageTo));
	}

	private afterSend(result, error) {
		if (this.termData != undefined) {
			this.updateTerms(result.id);
			this.closeDialog.emit();
		}

		if (result.priceSettingBoards) {
			this.priceSetting.priceSettingBoards = result.priceSettingBoards;
			this.priceSettingData.priceSettingBoards = result.priceSettingBoards;
		}

		if (error) {
			this.loader.hide();
			return;
		} else {
			this.infobox.success('Zapisano');
		}
	}

	protected updateTerms(priceSettingId) {
		this.termData = this.termData.map((item) => {
			item.priceSettings.termPriceSettings = priceSettingId;
			return item;
		});
		this.bag.put('/offer/term/bulk_update/', this.termData, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
		});
	}

	async submit(): Promise<void> {
		if (!this.validatePriceSettings()) {
			return;
		}

		const priceSettingBoards = this.board
			.filter((value) => value.costPLN !== undefined && value.sellingPrice !== undefined)
			.map((item) => ({
				id: null,
				board: item.id,
				cost: +item.cost,
				price: item.sellingPrice,
				isActive: !!item.isActive,
			}));
		const priceSettingsPriceOptions = this.priceOption
			.filter((value) => value.cost !== undefined)
			.map((obj) => ({
				id: null,
				priceOption: obj.id,
				methodValue: obj.cost,
				isActive: !!obj.isActive,
				currency: obj.currency,
				ageFrom: this.hasAgeRange(obj) ? (obj.ageFrom ?? null) : null,
				ageTo: this.hasAgeRange(obj) ? (obj.ageTo ?? null) : null,
			}));

		this.loader.show();

		if (this.data != undefined) {
			this.groupOfferSend(priceSettingsPriceOptions, priceSettingBoards);
		}

		if (this.productData != undefined) {
			await this.productSend(priceSettingsPriceOptions, priceSettingBoards);
		}

		if (this.termData != undefined) {
			this.termSend(priceSettingsPriceOptions, priceSettingBoards);
		}
	}

	updatePrice(price): number {
		if (typeof price === 'number') {
			return price * 100;
		}

		return null;
	}

	updatePercent(price: number): number {
		if (typeof price === 'number') {
			return price * 10;
		}

		return null;
	}

	constructor(
		protected infobox: InfoboxService,
		protected loader: LoaderService,
		protected bag: DataBagService,
		protected dateService: DateService,
	) {}

	protected readonly parseInt = parseInt;

	validatePriceSettings(): boolean {
		if (this.isSomeCostWithoutCurrency()) {
			return false;
		}

		if (this.isSomeAgeRangeInvalid()) {
			return false;
		}

		if (this.priceSettingData.crewCost === null) {
			this.infobox.error('Pole koszt nie może być puste!');

			return false;
		}
		return true;
	}
}
